import { SiteNavItem } from '@src/components/sco/nav/ScoSiteNavBar/index'
import { ScoUser } from '@src/graphql-types'

const notificationCount = 0

export const primaryNavItems = ({
  getBreakpointValue,
  currentUser,
  pathname,
}: {
  getBreakpointValue: any
  currentUser: ScoUser
  pathname: string
}): Array<SiteNavItem> => {
  const isLoggedIn = !!currentUser?.isRegistered

  const home: SiteNavItem = {
    linkProps: {
      title: isLoggedIn ? 'Dashboard' : 'Home',
      // children: <Icon as={LuHouse} fontSize={'1.5em'} />,
      href: isLoggedIn ? '/requests/manage' : '/',
    },
    activePaths: isLoggedIn ? ['/requests/manage'] : ['/'],
  }

  const pitchDecks: SiteNavItem = {
    linkProps: {
      title: 'Pitch Decks',
      href: '/pitch-decks',
    },
    activePaths: ['/pitch-decks'],
  }

  const advisors: SiteNavItem = {
    linkProps: {
      title: 'Advisors',
      href: '/advisors',
    },
    activePaths: ['/advisors'],
    items: [
      {
        linkProps: {
          title: 'Become an Advisor',
          href: '/advisors/become-a-startup-advisor',
        },
        activePaths: ['/advisors/become-a-startup-advisor'],
      },
    ],
  }

  const education: SiteNavItem = {
    linkProps: {
      title: 'Education',
      href: '/education',
    },
    activePaths: ['/education', '/articles', '/courses', '/videos', '/podcast', '/founder-interviews'],
    items: [
      {
        linkProps: {
          title: 'Courses',
          href: '/courses',
        },
        activePaths: ['/courses'],
      },
      {
        linkProps: {
          title: 'Articles',
          href: '/articles',
        },
        activePaths: ['/articles'],
      },
      {
        linkProps: {
          title: 'Founder Interviews',
          href: '/founder-interviews',
        },
        activePaths: ['/founder-interviews'],
      },
      {
        linkProps: {
          title: 'Podcast',
          href: '/podcast',
        },
        activePaths: ['/podcast'],
      },
      {
        linkProps: {
          title: 'Videos',
          href: '/videos',
        },
        activePaths: ['/videos'],
      },
      {
        linkProps: {
          title: 'Playbooks',
          href: '/playbooks',
        },
        activePaths: ['/playbooks'],
      },
      {
        linkProps: {
          title: 'Lexicon',
          href: '/lexicon',
        },
        activePaths: ['/lexicon'],
      },
    ],
  }

  const events: SiteNavItem = {
    linkProps: {
      title: 'Events',
      href: '/events',
    },
    activePaths: ['/events'],
    items: [
      {
        linkProps: {
          title: 'Upcoming',
          href: '/events/upcoming',
        },
        activePaths: ['/events/upcoming'],
      },
      {
        linkProps: {
          title: 'Workshops',
          href: '/events/workshops',
        },
        activePaths: ['/events/workshops'],
      },
      {
        linkProps: {
          title: 'Group Meetings',
          href: '/events/group-meetings',
        },
        activePaths: ['/events/group-meetings'],
      },
      {
        linkProps: {
          title: 'Office Hours',
          href: '/events/office-hours',
        },
        activePaths: ['/events/office-hours'],
      },
      {
        linkProps: {
          title: 'Public Events',
          href: '/events/public',
        },
        activePaths: ['/events/public'],
      },
      {
        linkProps: {
          title: 'My Events',
          href: '/events/my-events',
        },
        activePaths: ['/events/my-events'],
      },
    ],
  }

  const discussions: SiteNavItem = {
    linkProps: {
      title: 'Answers',
      href: '/posts',
    },
    activePaths: ['/posts'],
  }

  const members = {
    linkProps: {
      title: 'Members',
      href: '/members/matching',
    },
    activePaths: ['/members', '/experts', '/chat', '/founders'],
    items: [
      {
        linkProps: {
          title: 'Matching',
          href: '/members/matching',
        },
        activePaths: ['/members/matching'],
      },
      {
        linkProps: {
          title: 'Founders',
          href: '/founders',
        },
        activePaths: ['/founders'],
      },
    ].filter(Boolean),
  }

  const investors = {
    linkProps: {
      title: 'Investors',
      href: '/investors/search',
    },
    activePaths: ['/investors'],
  }

  const perks = {
    linkProps: {
      title: 'Perks',
      href: '/perks/partners',
    },
    activePaths: ['/perks'],
  }

  const tools = {
    linkProps: {
      title: 'Tools',
      href: '/tools',
    },
    activePaths: ['/tools', '/pitch-decks'],
  }

  const funding: SiteNavItem = {
    linkProps: {
      title: 'Funding',
      href: '/funding',
    },
    // badgeProps: process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== 'production' && { title: '•' },
    activePaths: ['/funding-accelerator', '/investors', '/investor-outreach', '/funding'],
    items: [
      {
        linkProps: {
          title: 'Investor Matching',
          href: '/funding',
        },
      },
      // {
      //   linkProps: {
      //     title: 'Pitch Deck Auditor',
      //     href: '/pitch-deck-auditor',
      //   },
      // },
      // {
      //   linkProps: {
      //     title: 'Funding Resources',
      //     href: '/funding',
      //   },
      // },
      {
        linkProps: {
          title: 'Investor Database',
          href: '/investors/search',
        },
      },
    ].filter(Boolean),
  }

  const requests: SiteNavItem = {
    linkProps: {
      title: 'Requests',
      href: '/requests',
    },
    activePaths: ['/requests'],
    items: [
      {
        linkProps: {
          title: 'Browse Requests',
          href: '/requests/browse',
        },
        activePaths: ['/requests/browse'],
      },
      {
        linkProps: {
          title: 'My Goals',
          href: '/requests/manage',
        },
        activePaths: ['/requests/manage'],
      },
      {
        linkProps: {
          title: 'My Commitments',
          href: '/requests/commitments',
        },
        activePaths: ['/requests/commitments'],
      },
      {
        linkProps: {
          title: 'My Offers',
          href: '/requests/my-offers',
        },

        activePaths: ['/requests/my-offers'],
      },
    ],
  }

  const customers: SiteNavItem = {
    linkProps: {
      title: 'Get Customers',
      href: '/get-customers',
    },
    activePaths: ['/get-customers'],
  }

  return [
    home,
    advisors,
    funding,
    pitchDecks,
    // requests,
    // process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== 'production' && customers,
    education,
    events,
    // discussions,
    // members,
    // perks,
    // process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== 'production' && tools,
  ].filter(Boolean)
}
